import { render, staticRenderFns } from "./RoadmapNotes.vue?vue&type=template&id=616c4052&scoped=true&"
import script from "./RoadmapNotes.vue?vue&type=script&lang=js&"
export * from "./RoadmapNotes.vue?vue&type=script&lang=js&"
import style0 from "./RoadmapNotes.vue?vue&type=style&index=0&id=616c4052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616c4052",
  null
  
)

export default component.exports